export const EQUIPMENT_ACTIONS = {
    EQUIPMENT_LIST : "EQUIPMENT_LIST"
}